import { render, staticRenderFns } from "./HomePurpose.vue?vue&type=template&id=f9cdc122&scoped=true"
import script from "./HomePurpose.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePurpose.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HomePurpose.vue?vue&type=style&index=0&id=f9cdc122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_dshyztwqotzq6hkhxg56wcmkza/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cdc122",
  null
  
)

export default component.exports